var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8232 8.73038H21.2757C21.6009 8.73038 21.9128 8.85957 22.1428 9.08953C22.3727 9.3195 22.5019 9.6314 22.5019 9.95661V24.6714C22.5019 24.9967 22.3727 25.3086 22.1428 25.5385C21.9128 25.7685 21.6009 25.8977 21.2757 25.8977H1.65592C1.33071 25.8977 1.01881 25.7685 0.788844 25.5385C0.55888 25.3086 0.429688 24.9967 0.429688 24.6714V9.95661C0.429688 9.6314 0.55888 9.3195 0.788844 9.08953C1.01881 8.85957 1.33071 8.73038 1.65592 8.73038H4.10839V7.50414C4.10839 5.55284 4.88355 3.68145 6.26333 2.30167C7.64311 0.921882 9.5145 0.146729 11.4658 0.146729C13.4171 0.146729 15.2885 0.921882 16.6683 2.30167C18.0481 3.68145 18.8232 5.55284 18.8232 7.50414V8.73038ZM2.88216 11.1828V23.4452H20.0495V11.1828H2.88216ZM16.3708 8.73038V7.50414C16.3708 6.20327 15.854 4.95568 14.9341 4.03582C14.0143 3.11597 12.7667 2.5992 11.4658 2.5992C10.1649 2.5992 8.91735 3.11597 7.99749 4.03582C7.07764 4.95568 6.56087 6.20327 6.56087 7.50414V8.73038H16.3708Z",
    fill: "#828893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.269df2385ca253a361fbd44198374476.svg";
export { ForwardRef as ReactComponent };